module.exports = __webpack_public_path__ + "static/media/react-icon.078a17e0.svg";